<template>
    <div>
        <div class="row mt-3 mb-7 justify-content-center">
            <div class="col-xl-3 col-6 tab-test-bird tab-material-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4">
                {{lesson.name}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points order-xl-3 order-3">
                <div class="zerno-points" v-if="!hidePoints">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1" v-if="materials[0].idelementtype === 'materials'">{{ $t('materials') }}</div>
                <div class="tab-video-notice-1" v-if="materials[0].idelementtype === 'vocabulary'">{{ $t('vocabulary') }}</div>
                <div class="tab-video-notice-1" v-if="materials[0].idelementtype === 'grammar'">{{ $t('grammar') }}</div>
            </div>
            <div class="col-12 order-5" v-if="materials.length > 1 || materials[0].idelementtype === 'materials'">
                <div class="row justify-content-center materilas-wrapper">
                    <div v-for="material in materials"
                         :key="material.id"
                         class="col-xl-3 col-7 text-center mb-xl-4">

                        <a target="_blank"
                           :href="material.url">
                            <img v-if="material.video_preview"
                                 class="mb-4 max-width-100 material-img"
                                 :src="material.video_preview">
                            <img v-else-if="isImageFile(material.url) && material.url"
                                 class="mb-4 max-width-100 material-img"
                                 :src="material.url">
                            <i v-else :class="`file-material-icon mb-4 fa fa-${getFileIcon(material.url)}`"></i>
                        </a>
                        <div class="material-link mt-1 mb-xl-3 mb-5">
                            <div><a target="_blank" :href="material.url">{{ material.element }}</a></div>
                            <base-button v-if="!isAndroidApp()" icon="fa fa-download" class="mt-4 pt-2 pb-2 pl-3 pr-3"
                                         @click="download(material.url, material.element)"
                                         :title="$t('save')"></base-button>
                            <base-button v-if="!isAndroidApp()" icon="fa fa-print" class="mt-4 pt-2 pb-2 pl-3 pr-3"
                                         @click="print(material.url)" :title="$t('print')"></base-button>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 order-5" v-else>
                <div class="row justify-content-center materilas-wrapper">
                    <div class="col-xl-8 col-12 text-center mb-xl-4 vh-100">
                        <a target="_blank"
                           :href="materials[0].url">
                            <img v-if="materials[0].video_preview"
                                 class="mb-4 max-width-100 material-img"
                                 :src="materials[0].video_preview">
                            <img v-else-if="isImageFile(materials[0].url) && materials[0].url"
                                 class="mb-4 max-width-100 material-img"
                                 :src="materials[0].url">
                            <object v-else class="mb-4 max-width-100" :data="materials[0].url" width="100%"
                                    height="80%"></object>
                        </a>
                        <div class="material-link mt-1 mb-xl-3 mb-5">
                            <div><a target="_blank" :href="materials[0].url">{{ materials[0].element }}</a></div>
                            <base-button v-if="!isAndroidApp()" icon="fa fa-download" class="mt-4 pt-2 pb-2 pl-3 pr-3"
                                         @click="download(materials[0].url, materials[0].element)"
                                         :title="$t('save')"></base-button>
                            <base-button v-if="!isAndroidApp()" icon="fa fa-print" class="mt-4 pt-2 pb-2 pl-3 pr-3"
                                         @click="print(materials[0].url)" :title="$t('print')"></base-button>
                        </div>

                    </div>
                </div>
            </div>


            <div class="col-12 order-6 mt-4 mb-xl-3 mb-3">
                <div class="row justify-content-center text-center">
                    <div class="col-xl-auto col-12" v-if="!isAndroidApp()">
                        <base-button class="btn-to-lessons-list pl-5 pr-5 mt-xl-0 mt-4" size="lg"
                                     @click="toLessons">
                            <i class="fa fa-bars"></i> {{ $t('to_lessons_list') }}
                        </base-button>
                    </div>
                    <div class="col-xl-auto col-12" v-if="nextId">
                        <base-button class="btn-to-next-lesson pl-5 pr-5 mt-xl-0 mt-4" size="lg"
                                     @click="toNextLesson">
                            {{ $t('next_lesson') }} <i class="fa fa-arrow-right"></i>
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import printJS from 'print-js'
    import download from 'downloadjs'
    import mime from 'mime-types'
    import {isAndroid} from "../data/AndroidApi";

    export default {
        name: "LessonMaterial",
        props: ['materials', 'lesson', 'points', 'nextId', 'hidePoints'],
        data() {
            return {}
        },
        methods: {
            print(url) {
                let extention
                if (url.includes('&X-Amz-')) {
                    extention = url.includes('.pdf?X-Amz') ? 'pdf' : 'image';
                } else {
                    extention = url.split('.').pop().toLowerCase();
                }
                if (extention === 'pdf')
                    printJS({ printable: url, type: 'pdf', showModal: true })
                else
                    printJS({ printable: url, type: 'image' })
            },

            download(url, filename) {
                const extention = url.split('?')[0].split('.').pop().toLowerCase();
                if (!filename.toLowerCase().endsWith(extention)) filename = filename + "." + extention
                var x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = "blob";
                x.onload = function (e) {
                    download(e.target.response, filename, mime.lookup(extention))
                }
                x.send();
            },

            newTab(url) {
                window.open(url, "_blank")
            },

            toNextLesson() {
                this.$router.push('/lesson/' + this.nextId)
            },

            toLessons() {
                this.$emit('tolessons')
            },

            getFileIcon(url) {
                let ext = this.getFileExt(url).toLowerCase()
                if (ext === "jpg" || ext === "jpe" || ext === "jpeg" || ext === "gif" || ext === "png") return "fa-file-image";
                if (ext === "pdf") return "file-pdf";
                if (ext === "doc" || ext === "docx") return "file-word";
                if (ext === "xsl" || ext === "xslx") return "file-excel";
                if (ext === "ppt" || ext === "pptx") return "file-powerpoint";
                if (ext === "zip" || ext === "rar") return "file-archive";
                return "fa-file";
            },

            isImageFile(url) {
                let ext = this.getFileExt(url).toLowerCase()
                return ext === "jpg" || ext === "jpe" || ext === "jpeg" || ext === "gif" || ext === "png";
            },

            getFileExt(url) {
                return url.split(/#|\?/)[0].split('.').pop().trim();
            },

            isAndroidApp() {
                return isAndroid()
            },

        }
    }
</script>

<style scoped>

</style>
